import React, { useState } from 'react';
import { modules } from '../../onboardingContent';
import { logEvent } from '../../lib/analytics';
import SocraticGuideChat from './SocraticGuideChat';

export default function PathScreen({ worldview, onDone }) {
  const filtered = modules.filter(m => m.worldviewTags.includes(worldview));
  const questions = filtered.filter(m => m.type === 'question');
  const encounters = filtered.filter(m => m.type === 'encounter');
  const practices = filtered.filter(m => m.type === 'practice');
  const [tab, setTab] = useState('question');

  const renderList = list => (
    <div>
      {list.map(m => (
        <div key={m.id} className="mb-4">
          <h4>{m.title}</h4>
          <p>{m.body}</p>
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={() => logEvent('complete_module', { moduleId: m.id, type: m.type })}
          >
            Done
          </button>
        </div>
      ))}
    </div>
  );

  return (
    <div className="container mt-4">
      <h2 className="mb-3 text-capitalize">{worldview} path</h2>
      <ul className="nav nav-tabs mb-3" role="tablist">
        <li className="nav-item" role="presentation">
          <button className={`nav-link ${tab==='question'?'active':''}`} onClick={() => setTab('question')}>Questions</button>
        </li>
        <li className="nav-item" role="presentation">
          <button className={`nav-link ${tab==='encounter'?'active':''}`} onClick={() => setTab('encounter')}>Encounter</button>
        </li>
        <li className="nav-item" role="presentation">
          <button className={`nav-link ${tab==='practice'?'active':''}`} onClick={() => setTab('practice')}>Practice</button>
        </li>
      </ul>
      {tab === 'question' && renderList(questions)}
      {tab === 'encounter' && renderList(encounters)}
      {tab === 'practice' && renderList(practices)}
      {worldview === 'atheist' && (
        <div className="mt-4">
          <h3 className="mb-2">Chat with Socratic Christian Guide</h3>
          <SocraticGuideChat />
        </div>
      )}
      <div className="text-right mt-4">
        <button className="btn btn-warning" onClick={onDone}>
          Im ready for the pledge
        </button>
      </div>
    </div>
  );
}
